import React, { useState, useRef, useEffect, useMemo } from 'react';
import { ArrowRightIcon, X } from 'lucide-react';
import { useIsMobile } from '../../submission_boards/component/useIsMobile';
import { getStorageNotification, saveStorageNotification } from '../../directory/storageUtils';

interface ProTrialIconProps {
  isTop: boolean;
}

const ProTrialIcon: React.FC<ProTrialIconProps> = ({ isTop }) => {
  const isMobile = useIsMobile(); // Hook is used here
  const componentRef = useRef<HTMLDivElement>(null);
  const [showList, setShowList] = useState(false);
  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (componentRef.current && !componentRef.current.contains(event.target as Node)) {
        setShowList(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleTap = (e) => {
    e.stopPropagation();
    if(isMobile) {
        const showMobileTooltip = getStorageNotification('user_protrial_tooltip') == 2 ? false : true;
        saveStorageNotification('user_protrial_tooltip', 2);
        if(showMobileTooltip) {
            setShowList((prev) => !prev);
            return;
        }
    }
    window.location.href = '/auth/account';
  };
  return (
    <div
      className={`relative flex flex-row justify-center items-center py-1 px-2 gap-1 bg-black border border-gray-500 rounded-full cursor-pointer`}
      // onClick={() => {
      //     if (searchInputRef.current) {
      //         searchInputRef.current.focus();
      //     }
      // }}
      ref={componentRef}
      onClick={handleTap}
      onMouseEnter={() => {
        if (!isMobile) {
        setShowList(true);
        }
      }}
      onMouseLeave={() => {
        if (!isMobile) {
        setShowList(false);
        }
      }}
    >
      <div className="font-semibold text-xs text-center text-white">PRO <br className='block sm:hidden' />TRIAL</div>
      {showList && (
        <div
          className={
            'flex flex-col justify-center px-5 py-4 shadow-xl-0-19-40-8 rounded-lg z-50' +
            ((isTop ? ' bottom-full mb-4 ' : ' top-full mt-4 ') +
              ' absolute left-1/2 transform -translate-x-1/2 ')
          }
            style={{
                width:'15.625rem',
              background: '#EEF6FF',
              border: '1px solid #3C82F640',
            }}
        >
          {isTop ? (
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full mb-1">
              <svg
                width="25"
                height="16"
                viewBox="0 0 25 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9881 15.2543C11.7857 16.1752 13.2143 16.1752 14.0119 15.2543L23.9235 3.80931C25.0452 2.51402 24.1251 0.5 22.4116 0.5H2.58838C0.874875 0.5 -0.0452271 2.51402 1.07652 3.80931L10.9881 15.2543Z"
                  fill="#F9FAFB"
                />
              </svg>
            </div>
          ) : (
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-full -mt-1">
              <svg
                width="25"
                height="16"
                viewBox="0 0 25 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ transform: 'rotate(180deg)' }}
              >
                <path
                  d="M10.9881 15.2543C11.7857 16.1752 13.2143 16.1752 14.0119 15.2543L23.9235 3.80931C25.0452 2.51402 24.1251 0.5 22.4116 0.5H2.58838C0.874875 0.5 -0.0452271 2.51402 1.07652 3.80931L10.9881 15.2543Z"
                  fill="#F9FAFB"
                />
              </svg>
            </div>
          )}

          <div
            className="flex flex-col justify-center"
            // style={{
            //   background: '#EEF6FF',
            //   border: '1px solid #3C82F640',
            // }}
          >
              <div
            className="flex flex-col justify-start items-start p-0 gap-2 font-regular text-sm"
            style={{
            }}
          >
            <div className='font-semibold'>Pro Trial Access</div>
            <div>You currently have access to Pro profile tools, so you can explore everything FILMIK offers.</div>
            <div>Before the trial ends, you can choose to continue with Pro to keep using these tools.</div>
            <div>If you don’t, your account simply continues on the Free Basic plan.</div>
            <div>Nothing about your profile or your ability to work on projects changes.</div>
          </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProTrialIcon;
